const { MICROX_ENV } = process.env;

const { AWP_DEPLOY_ENV = 'local' } = MICROX_ENV;

const isProd = AWP_DEPLOY_ENV === 'production' || AWP_DEPLOY_ENV === 'staging';

const isLocal = AWP_DEPLOY_ENV === 'local';

export default {
  AWP_DEPLOY_ENV,
  isProd,
  isLocal,
  MICROX_ENV,
};
